// #region License

/**
 * @license
 * Copyright (C) Mairistem
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 *
 * Proprietary and confidential
 */

// #endregion

/* eslint-disable */

import * as React from "react";
import { Button, Modal, Portal, Segment } from "semantic-ui-react";
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
export const DashboardBarConfirm = props => {
  const {
    children,
    header,
    content,
    container,
    open,
    onConfirm,
    onCancel
  } = props;
  const handleCancel = React.useCallback(() => {
    onCancel?.();
  }, [onCancel]);
  const handleConfirm = React.useCallback(() => {
    onConfirm?.();
  }, [onConfirm]);
  const actions = React.useMemo(() => children || /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(Button, {
      basic: true,
      size: "small",
      icon: "cancel",
      content: "Annuler",
      onClick: handleCancel
    }), /*#__PURE__*/_jsx(Button, {
      primary: true,
      icon: "check",
      content: "Confirmer",
      onClick: handleConfirm
    })]
  }), [children, handleCancel, handleConfirm]);
  const modal = React.useMemo(() => /*#__PURE__*/_jsxs(Modal, {
    mountNode: container,
    open: open,
    size: "small",
    closeOnDimmerClick: true,
    closeOnDocumentClick: true,
    closeOnEscape: true,
    onClose: handleCancel,
    children: [/*#__PURE__*/_jsx(Modal.Header, {
      as: Segment,
      inverted: true,
      children: header
    }), /*#__PURE__*/_jsx(Modal.Content, {
      children: content
    }), /*#__PURE__*/_jsx(Modal.Actions, {
      children: actions
    })]
  }), [container, open, header, content, actions, handleCancel]);
  return /*#__PURE__*/_jsx(Portal, {
    open: open,
    transition: {
      animation: "scale"
    },
    closeOnDocumentClick: false,
    closeOnTriggerClick: false,
    closeOnTriggerBlur: false,
    mountNode: container,
    "data-sentry-element": "Portal",
    "data-sentry-component": "DashboardBarConfirm",
    "data-sentry-source-file": "DashboardBarConfirm.tsx",
    children: modal
  });
};
export default DashboardBarConfirm;